import { isNil } from 'lodash';
import * as validationMessages from 'common/constants/messages/validations';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { SELECTION, WEIGHTING } from 'pages/Valuations/approaches/guidelinePublicCompanies/constants';
import { LAST_MIDDLE_COLUMN_INDEX } from 'pages/Valuations/approaches/guidelinePublicCompanies/gpc/config/constants';
import { handleWeightingProbability } from 'pages/ValuationsAllocation/util';

type ValidationsParams = {
  cell: ICell;
  addFeedback: (message: string) => void;
  removeFeedback: (message: string) => void;
  parsedColumns?: { [key: string]: ICell };
  removeFeedbackFromCell: (cell: ICell) => void;
};

const validations = ({
  cell,
  addFeedback,
  removeFeedback,
  parsedColumns,
  removeFeedbackFromCell,
}: ValidationsParams) => {
  const { alias, value } = cell;
  if (alias === SELECTION && cell.y! > LAST_MIDDLE_COLUMN_INDEX) {
    // if cell value is '0' then addFeedback(validationMessages.IS_REQUIRED_ERROR);

    if (isNil(value)) {
      addFeedback(validationMessages.IS_REQUIRED_ERROR);
    } else {
      removeFeedback(validationMessages.IS_REQUIRED_ERROR);
    }
  }

  if (alias === WEIGHTING) {
    handleWeightingProbability({
      parsedColumns,
      addFeedback,
      removeFeedback,
      weightingAliasToSearch: WEIGHTING,
      removeFeedbackFromCell,
      shouldMultiplyBy100: false,
    });
  }
};

export default validations;
